import type {PropsWithChildren} from 'react';
import {type ComponentProps, type FC} from 'react';
import type {VariantProps} from 'class-variance-authority';
import {cva} from 'class-variance-authority';

import {cn} from '@/modules/foundation/shared/tailwind';

const select = cva(
	[
		'rounded-sm border-2 border-neutral-600 bg-neutral-800/50 p-0 text-neutral-100',
		'focus:ring-primary focus:ring-2 focus:ring-offset-2 focus:ring-offset-neutral-800 ',
		'disabled:cursor-not-allowed disabled:bg-neutral-700 disabled:text-neutral-400',
	],
	{
		variants: {
			size: {
				sm: 'text-sm lg:text-base h-8 lg:h-10 ps-2 pe-8 lg:ps-3 lg:pe-9 border',
				md: 'text-base lg:text-lg h-10 lg:h-12 ps-3 pe-9 lg:ps-4 lg:pe-10 border-2',
				lg: 'text-lg lg:text-xl h-12 lg:h-14 ps-4 pe-10 lg:ps-5 lg:pe-11 border-2',
			},
		},
		defaultVariants: {
			size: 'md',
		},
	},
);

export type SelectProps = VariantProps<typeof select> & Omit<ComponentProps<'select'>, 'size'>;

export const Select: FC<PropsWithChildren<SelectProps>> = ({
	className,
	size,
	children,
	...restInputProps
}) => {
	return (
		<select className={cn(select({size, className}))} {...restInputProps}>
			{children}
		</select>
	);
};
